module.exports = __webpack_public_path__ + "img/shedule-flow-svg-picture.dbdb65a2.svg";